import { comparisonData } from '@/mocks/categories';

export default function ComparisonTable() {
  return (
    <section id="comparison" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-wider mb-3 font-label bg-secondary-100/70 px-3 py-1 rounded-full">
            Agent Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight tracking-tight mb-3">
            Compare Proxy Shopping Platforms
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto font-body leading-relaxed">
            Find the best agent for your needs. Our comparison helps you choose the right platform based on spreadsheet quality, shipping speed, and pricing.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-background-200/50">
                <th className="py-4 px-5 md:px-6 text-xs font-semibold text-foreground-600 uppercase tracking-wider font-label whitespace-nowrap">Platform</th>
                <th className="py-4 px-5 md:px-6 text-xs font-semibold text-foreground-600 uppercase tracking-wider font-label whitespace-nowrap">Spreadsheet Quality</th>
                <th className="py-4 px-5 md:px-6 text-xs font-semibold text-foreground-600 uppercase tracking-wider font-label whitespace-nowrap">Shipping Speed</th>
                <th className="py-4 px-5 md:px-6 text-xs font-semibold text-foreground-600 uppercase tracking-wider font-label whitespace-nowrap">Price</th>
                <th className="py-4 px-5 md:px-6 text-xs font-semibold text-foreground-600 uppercase tracking-wider font-label whitespace-nowrap">Beginner Friendly</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, i) => (
                <tr key={row.platform} className={`${i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'} hover:bg-accent-50/50 transition-colors`}>
                  <td className="py-4 px-5 md:px-6">
                    <span className="font-heading text-sm font-semibold text-foreground-950 whitespace-nowrap">{row.platform}</span>
                  </td>
                  <td className="py-4 px-5 md:px-6">
                    <span className={`inline-flex items-center gap-1.5 text-xs font-medium rounded-full px-2.5 py-1 ${
                      row.quality === 'Very High' ? 'bg-accent-100/80 text-accent-700' :
                      row.quality === 'High' ? 'bg-secondary-100/80 text-secondary-700' :
                      'bg-background-200/80 text-foreground-600'
                    } font-label`}>
                      {row.quality === 'Very High' && <i className="ri-star-fill text-[10px]"></i>}
                      {row.quality}
                    </span>
                  </td>
                  <td className="py-4 px-5 md:px-6">
                    <span className={`text-xs font-medium font-label ${
                      row.speed === 'Fast' ? 'text-accent-600' :
                      'text-foreground-600'
                    }`}>{row.speed}</span>
                  </td>
                  <td className="py-4 px-5 md:px-6">
                    <span className={`text-xs font-medium font-label ${
                      row.price === 'Very Low' ? 'text-accent-600' :
                      row.price === 'Low' ? 'text-secondary-600' :
                      'text-foreground-600'
                    }`}>{row.price}</span>
                  </td>
                  <td className="py-4 px-5 md:px-6">
                    <span className="inline-flex items-center gap-1 text-xs text-accent-600 font-medium font-label">
                      <i className="ri-check-line"></i>
                      {row.beginner}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="text-center mt-5 text-xs text-foreground-500 font-body">
          Data updated weekly. Last updated: July 2026. For detailed comparison, explore our full spreadsheet guides.
        </p>
      </div>
    </section>
  );
}